const experiences = [
  {
    date: "ABR/2025 & OUT/2024",
    title: "Designer Gr\xE1fica (Tempor\xE1ria)",
    subtitle: "Ag\xEAncia Razow",
    details: [
      "Cria\xE7\xE3o de pe\xE7as digitais e impressas para campanhas pontuais.",
      "Recontratada pela qualidade e agilidade nas entregas.",
    ],
  },
  {
    date: "FEV/2024 - DEZ/2024",
    title: "Designer Gr\xE1fica & Social Media",
    subtitle: "D&D Cosm\xE9ticos",
    details: [
      "Desenvolvimento de KVs, impressos e conte\xFAdo para redes sociais.",
      "Aumento do engajamento digital com pe\xE7as promocionais.",
    ],
  },
  {
    date: "2018 - Presente",
    title: "Multidisciplinar Freelancer",
    subtitle: "Muzza Studio",
    details: [
      "Entrega de projetos de design, web e editorial para diversos clientes (PMEs e pessoas f\xEDsicas).",
      "Atua\xE7\xE3o em projetos para clientes como Razow, Sapiens e Eleve Comunica\xE7\xE3o.",
    ],
  },
  {
    date: "JAN/2022 - DEZ/2022",
    title: "Designer Gr\xE1fica",
    subtitle: "Funda\xE7\xE3o de Arte de Niter\xF3i",
    details: [
      'Liderou branding e redes sociais de institui\xE7\xF5es culturais e dire\xE7\xE3o de arte do ciclo "Modernismo(s)".',
    ],
  },
  {
    date: "SET/2020 - DEZ/2021",
    title: "Designer Gr\xE1fica",
    subtitle: "Ag\xEAncia Razow",
    details: [
      "Cria\xE7\xE3o de identidades e conte\xFAdos para Evelyn Regly, VacaCast e MyMake.",
      "Desenvolvimento da identidade visual completa do podcast VacaCast.",
    ],
  },
  {
    date: "FEV/2021 - OUT/2021",
    title: "Diagramadora & Capista",
    subtitle: "Editora Dial\xE9tica",
    details: [
      "Diagrama\xE7\xE3o de livros f\xEDsicos/digitais e cria\xE7\xE3o de capas para autores.",
    ],
  },
  {
    date: "JAN/2018 - DEZ/2019",
    title: "Artista 2D & UI/UX Designer",
    subtitle: "ICAD / Vision Lab, PUC-Rio",
    details: [
      "Atua\xE7\xE3o no jogo Shape Arena (Premiado na SBGames 2019) como artista e UI designer.",
      'Cria\xE7\xE3o do projeto solo de card-game "Constel\xE1rio", exibido na SBGames 2019.',
    ],
  },
];

const education = [
  {
    date: "FEV/24 - MAI/26",
    title: "An\xE1lise e Desenvolvimento de Sistemas",
    subtitle: "Universidade Presbiteriana Mackenzie",
  },
  {
    date: "FEV/20 - FEV/21",
    title: "P\xF3s-gradua\xE7\xE3o em UI/UX",
    subtitle: "Faculdade Unyleya",
  },
  {
    date: "AGO/15 - DEZ/19",
    title: "Desenho Industrial (Bacharelado)",
    subtitle: "PUC-Rio",
  },
  {
    title: "Cursos Livres Relevantes",
    description:
      "UX/UI & Front-End (Origamid), Bootcamp Design (Baseline), Google UX Design (Coursera).",
  },
];

export { experiences, education };
